import { updateCompanyCustomerContactSchema } from '../../../../shared/modules/contacts/validators/schemas/update-company-customer-contact.schema';
import { updateIndividualCustomerContactSchema } from '../../../../shared/modules/contacts/validators/schemas/update-individual-customer-contact.schema';
import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CustomerTypeEnum } from '../../../customers';
import { TenantContactDto } from '../../dtos/tenant-contact.dto';

/**
 * Validates contact record.
 * @param contact - The contact record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const isValidCustomerContact = (
	contact: TenantContactDto,
	customerRecordCategory: CustomerTypeEnum,
	legalAge?: number | null,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!contact) throw new Error('Contact is required');

	// Validate
	switch (customerRecordCategory) {
		case CustomerTypeEnum.INDIVIDUAL: {
			// Check
			if (legalAge == null) {
				throw new Error(
					`legalAge is required for customer with type ${customerRecordCategory}`,
				);
			}

			const { error } = updateIndividualCustomerContactSchema(
				legalAge,
			).validate(contact, {
				abortEarly,
			});

			// Check
			if (error) {
				return {
					isValid: false,
					errors: error.details?.map((e) => e.message),
				};
			}

			break;
		}

		case CustomerTypeEnum.COMPANY: {
			const { error } = updateCompanyCustomerContactSchema().validate(contact, {
				abortEarly,
			});

			// Check
			if (error) {
				return {
					isValid: false,
					errors: error.details?.map((e) => e.message),
				};
			}

			break;
		}
	}

	// Return
	return { isValid: true };
};
